import { render, staticRenderFns } from "./TipComModel.vue?vue&type=template&id=6809b674&scoped=true"
import script from "./TipComModel.vue?vue&type=script&lang=js"
export * from "./TipComModel.vue?vue&type=script&lang=js"
import style0 from "./TipComModel.vue?vue&type=style&index=0&id=6809b674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809b674",
  null
  
)

export default component.exports